import React from 'react';

const IcLoadingDots = ({ width, height }: { width?: string; height?: string }) => {
    return (
        <svg width='22' height='4' viewBox='0 0 22 4' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <circle cx='2' cy='2' r='2' fill='#5A5C63' />
            <circle cx='11' cy='2' r='2' fill='#5A5C63' />
            <circle cx='20' cy='2' r='2' fill='#5A5C63' />
        </svg>
    );
};

export default IcLoadingDots;
